import { Divider } from "@mui/material";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { priceRowStyle, priceLabelStyle, priceValueStyle, discountLabelStyle, discountValueStyle, totalLabelStyle, totalValueStyle } from "./CouponStyles";
import {numberFormatter} from "@ecommerce/shared-utils";

export interface PriceSummary {
    subtotal: number;
    discount: number;
    shipping: number;
    shippingOriginalCost?: number;
    shippingDiscount?: number;
    shippingApplyCoupon: boolean;
    isShippingToBeAgreed?: boolean;
    total: number;
}


export const PriceSummary: React.FC<{ summary: PriceSummary, hasSelectedShippingOption?: boolean; }> = ({ summary, hasSelectedShippingOption = false }) => {
  const hasShippingDiscount = (summary.shippingDiscount ?? 0) > 0;
  const originalShippingCost = summary.shippingOriginalCost ?? summary.shipping;

    const shippingLabel = !hasSelectedShippingOption
        ? "Todavia no se seleccionó una opcion"
        : summary.isShippingToBeAgreed
            ? "A convenir"
            : summary.shipping === 0
                ? "Gratis"
                : `$${numberFormatter.toStringWithAmount(summary.shipping)}`;
  
  return (
    <>
      <Box sx={priceRowStyle}>
        <Typography sx={priceLabelStyle}>Subtotal</Typography>
        <Typography sx={priceValueStyle}>${numberFormatter.toStringWithAmount(summary.subtotal)}</Typography>
      </Box>
      
      {summary.discount > 0 && (
        <Box sx={priceRowStyle}>
          <Typography sx={discountLabelStyle}>Descuento</Typography>
          <Typography sx={discountValueStyle}>- ${numberFormatter.toStringWithAmount(summary.discount)}</Typography>
        </Box>
      )}

      <Box sx={priceRowStyle}>
        <Typography sx={priceLabelStyle}>Envío</Typography>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          {hasShippingDiscount && originalShippingCost > 0 && (
            <Typography 
              sx={{ 
                ...priceValueStyle,
                textDecoration: 'line-through',
                color: '#999'
              }}
            >
              ${numberFormatter.toStringWithAmount(originalShippingCost)}
            </Typography>
          )}
          <Typography sx={hasShippingDiscount ? discountValueStyle : priceValueStyle}>
            {shippingLabel}
          </Typography>
        </Box>
      </Box>

      <Divider sx={{ my: 2 }} />

      <Box sx={priceRowStyle}>
        <Typography sx={totalLabelStyle}>Total</Typography>
        <Typography sx={totalValueStyle}>{numberFormatter.toStringWithAmount(summary.total, '$')}</Typography>
      </Box>
    </>
  );
};














